import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router";
import TherapistConstellationPage from "./ui/pages/TherapistConstellationPage";
import PatientConstellationPage from "./ui/pages/PatientConstellationPage";

const AvatarConfigurator = lazy(() => import("./avatar/AvatarConfigurator"));

// Therapist routes — mounted INSIDE the protected app shell.
export const constellationRoutes: RouteObject[] = [
    // Static path before the :boardId param (ranked routing handles this anyway).
    {
        path: "/constellation/avatar",
        element: (
            <Suspense fallback={null}>
                <AvatarConfigurator />
            </Suspense>
        ),
    },
    { path: "/constellation/:boardId", element: <TherapistConstellationPage /> },
];

/**
 * The therapist's board with no app chrome, framed inside a call. Protected,
 * like the board itself; mounted beside the meeting routes, outside the app
 * shell, because a sidebar and header inside a slot of the call's stage would
 * leave the board no room.
 */
export const constellationMeetingRoutes: RouteObject[] = [
    { path: "/meeting-board/constellation/:boardId", element: <TherapistConstellationPage embedded /> },
];

// Patient route — PUBLIC, mounted OUTSIDE ProtectedRoute/AppLayout.
export const constellationPublicRoutes: RouteObject[] = [
    { path: "/constellation/patient/:token", element: <PatientConstellationPage /> },
];
